<template>
    <v-card
      width="600"
      outlined
      height="310"
      class="overflow-y-auto"
      style="border-radius: 5px;"

    >
    <v-app-bar
            flat
            color="white"

            float
          >
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon v-if="data.roles[0].name=='resource'" color="gray" @click="go('/statics/user/' + data.id + '/team/' + data.pivot.team_id)"><v-icon>bar_chart</v-icon></v-app-bar-nav-icon>
            <v-app-bar-nav-icon color="gray" @click="team_user_detail()"><v-icon>info</v-icon></v-app-bar-nav-icon>

    </v-app-bar>
      <v-list-item three-line style="margin-top: -30px; ">
        <v-list-item-avatar
          tile
          size="80"
        >
            <v-img v-if="data.avatar" :src="data.avatar" style="border-radius: 50%;" max-width="80px" />
            <v-icon v-else x-large style="border-radius: 50%; background-color: lightgray;">person</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title class="text-h6 mb-1">
                {{ data.name }}
          </v-list-item-title>

          <v-list-item-subtitle>{{ data.qualification }}</v-list-item-subtitle>
        </v-list-item-content>



      </v-list-item>

      <v-card-text>
      <v-list-item v-for="(ordered_user_target, outid) in typeOrderedUserTargets()" :key="outid">

        <v-list-item-content>
            <v-list-item-title>
                {{ ordered_user_target.target.name }}
          </v-list-item-title>
            <v-progress-linear
            :value="percUserTargetActivities(ordered_user_target)"
            :color="percUserTargetWorkedCustomColor(ordered_user_target)"
            height="20"
            style="min-width: 100px; border-radius: 8px;"
        >

        <small>{{ countCompletedUserActivities(ordered_user_target) }} / {{ ordered_user_target.user_activities.length }} {{ trans('users_targets_progressions.fields.activities')}}</small>

        </v-progress-linear>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
    </v-card>
  </template>
<script>


export default {

    name: "user-card",

    props: {
        user: { type: Object , default:{} },
        team_user_action: { default: '' }


    },
    data() {
        let data = this.user;


        return {
            data
        }
    },

    mounted() {
    },
    methods: {

        typeOrderedUserTargets() {

            let completed   = [];
            let in_progress = [];
            let not_exec    = [];



            for(let user_target of this.data.user_targets) {
                if(user_target.target.type == 'P') continue;

                if(user_target.started !== undefined && user_target.started !== null) {

                    if(user_target.ended !== undefined && user_target.ended !== null) {
                        completed.push(user_target);
                    } else {
                        in_progress.push(user_target);
                    }

                } else {
                    not_exec.push(user_target);
                }

            }

                const all = [...completed, ...in_progress, ...not_exec];

            return all;
        },

        perc(max, current) {
            let kx = 100.0 / parseFloat(max);
            let y = parseFloat(current) * kx;
            return Math.round(y * 100.0) / 100.0;

        },

        percUserTargetActivities(user_target) {
                let tot_activities = user_target.user_activities.length;
                let completed_activities = this.countCompletedUserActivities(user_target);
                return this.perc(tot_activities, completed_activities);
        },

        percUserTargetWorkedCustomColor(user_target) {
                    let perc = this.percUserTargetActivities(user_target);


                    // default green
                    let color = '#4CAF50'; // 100%
                    let background_color = '#A5D6A7';

                    if(perc < 25.0) {
                        // red
                        color = '#F44336';
                        background_color = '#EF9A9A';

                    } else if(perc <= 50.0) {
                        // orange
                        color = '#FFB74D'; // orange lighten-2
                        background_color = '#FFE0B2'; // orange lighten-4


                    } else if(perc < 75.0) {
                        // orange
                        color = '#FF9800';
                        background_color = '#FFE0B2';


                    } else if(perc > 105) {

                        background_color = '#EF9A9A';

                        if(perc < 110) {
                            // lime darken-4
                            color = '#827717';

                        } else if(perc < 125) {
                            // deep-orange darken-4
                            color = '#BF360C';

                        } else if(perc < 150) {
                            // red accent-4
                            color = '#D50000';

                        } else if(perc < 175) {
                            // pink accent-4
                            color = '#C51162';

                        } else if(perc > 175) {
                            // purple accent-4
                            color = '#AA00FF';
                        }

                    }

                    return color;
        },


        countCompletedUserActivities(user_target) {

            let completed = 0;

            for(let user_activity of user_target.user_activities) {

                if(user_activity.ended !== undefined && user_activity.ended !== null) {
                    completed++;
                }
            }

            return completed;
        },


        team_user_detail() {
            let action = this.team_user_detail_action;

            window.location.href = action;

        },

        go(url) {
            window.location.href = url;
        }

    },

    computed: {

        team_user_detail_action() {
            let user_id = this.data.id;
            return this.team_user_action + '/' + user_id;
        }





    }


}

</script>
